import { render, staticRenderFns } from "./resource-status.vue?vue&type=template&id=d99129d6&scoped=true"
import script from "./resource-status.vue?vue&type=script&lang=js"
export * from "./resource-status.vue?vue&type=script&lang=js"
import style0 from "./resource-status.vue?vue&type=style&index=0&id=d99129d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99129d6",
  null
  
)

export default component.exports